import {Chapters, Chapter} from '../../models/Chapters';

class QPVChaptersMapper {
  constructor(response) {
    this.response = response;
  }

  map() {
    this.chapters = new Chapters();

    const rawChapters = this.response.chapters || [];
    rawChapters.forEach(rawChapter => {
      const {offset, value} = rawChapter;
      this.chapters.push(new Chapter({
        offset,
        value
      }));
    });

    return this.chapters;
  }
}

export default QPVChaptersMapper;
